import parse from 'date-fns/parse';

import store from './index';

const state = {
  applications: [],
  applicationsFetched: false,
};

const getters = {
  editorsApplications(localState) {
    return localState.applications;
  },
  allApplications(localState) {
    return localState.applications.filter(item => !item.is_created_by_editor);
  },
  openedApplications(localState) {
    return localState.applications.filter(item => item.is_registration_opened && !item.is_full);
  },
  reservedApplications(localState) {
    return localState.applications.filter(item => item.is_full);
  },
  userApplications(localState) {
    const usserAppIds = store.state.auth.user.applications.map(item => item.games_event_day_id);
    return localState.applications.filter(item => usserAppIds.indexOf(item.uuid) >= 0);
  },
  filtredApplication(localState, filterId) {
    return localState.applications.filter(item => item.event_record_id === filterId);
  },
  findApplicationById(localState, filterId) {
    return localState.applications.find(item => item.uuid === filterId);
  },
  applicationsFetched(localState) {
    return localState.applicationsFetched;
  },
};

const mutations = {
  SET_APPLICATIONS(localState, applications) {
    applications.sort((itemA, itemB) => {
      const a = parse(itemA.played_at);
      const b = parse(itemB.played_at);

      const result = a > b ? 1 : a < b ? -1 : 0;
      return result;
    });
    localState.applications = applications;
  },
  SET_APPLICATIONS_IS_FETCHED(localState, isFetched) {
    localState.applicationsFetched = isFetched;
  },
  ADD_APPLICATION(localState, application) {
    localState.applications = [...application, ...localState.applications];
  },
  REMOVE_APPLICATION(localState, applicationId) {
    localState.applications = localState.applications.filter(item => item.uuid !== applicationId);
  },
  UPDATE_APPLICATION(localState, application) {
    Object.assign(localState.applications.find(item => item.uuid === application.event_day_id || item.uuid === application.uuid), application);
  },
};

const actions = {
  setApplications({ commit }, applications) {
    commit('SET_APPLICATIONS', applications);
  },
  setApplicationIsFetched({ commit }, isFetched) {
    commit('SET_APPLICATIONS_IS_FETCHED', isFetched);
  },
  addApplication({ commit }, application) {
    commit('ADD_APPLICATION', application);
  },
  removeApplication({ commit }, applicationId) {
    commit('REMOVE_APPLICATION', applicationId);
  },
  updateApplication({ commit }, application) {
    commit('UPDATE_APPLICATION', application);
  },
};
export default {
  mutations,
  actions,
  state,
  getters,
};
